import React from 'react';
import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type TaskDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const TaskDrillDownTableHeader: React.FC<TaskDrillDownTableHeaderProps> = ({
  handleSort,
}) => {
  const headCells = [
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_NUMBER,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TASK_NUMBER'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TASK_NAME,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TASK_NAME'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.STATUS,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.STATUS'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TYPE,
      content: intl.get('DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TYPE'),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROJECT,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROJECT'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.PROGRAMS,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.PROGRAMS'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ASSIGNEES,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ASSIGNEES'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.START_DATE,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.START_DATE'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DUE_DATE,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.DUE_DATE'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DEMAND_EST_HOURS,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.DEMAND_EST_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ALLOCATED_HOURS,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ALLOCATED_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Task',
      columnName: TASK_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ACTUAL_HOURS,
      content: intl.get(
        'DASHBOARDS_TASK_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ACTUAL_HOURS'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default TaskDrillDownTableHeader;
